"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultHttpClient = void 0;
const axios_1 = __importDefault(require("axios"));
const http_response_1 = require("../http/http-response");
const http_error_1 = require("../http/http-error");
class DefaultHttpClient {
    constructor(options) {
        this.options = options;
        this.instance = this.createInstance(this.options);
    }
    createInstance(options) {
        return axios_1.default.create(options);
    }
    request(options) {
        return this.instance
            .request(options)
            .then((response) => this.handleResponse(response))
            .catch((e) => {
            throw this.handleError(e);
        });
    }
    get(url, options) {
        return this.instance
            .get(url, options)
            .then((response) => this.handleResponse(response))
            .catch((e) => {
            throw this.handleError(e);
        });
    }
    delete(url, options) {
        return this.instance
            .delete(url, options)
            .then((response) => this.handleResponse(response))
            .catch((e) => {
            throw this.handleError(e);
        });
    }
    head(url, options) {
        return this.instance
            .head(url, options)
            .then((response) => this.handleResponse(response))
            .catch((e) => {
            throw this.handleError(e);
        });
    }
    post(url, data, options) {
        return this.instance
            .post(url, data, options)
            .then((response) => this.handleResponse(response))
            .catch((e) => {
            throw this.handleError(e);
        });
    }
    put(url, data, options) {
        return this.instance
            .put(url, data, options)
            .then((response) => this.handleResponse(response))
            .catch((e) => {
            throw this.handleError(e);
        });
    }
    patch(url, data, options) {
        return this.instance
            .patch(url, data, options)
            .then((response) => this.handleResponse(response))
            .catch((e) => {
            throw this.handleError(e);
        });
    }
    handleError({ message, response }) {
        return new http_error_1.HttpError({ message, response: this.handleResponse(response) });
    }
    handleResponse(response) {
        if (response) {
            const { data, ...rest } = response;
            return new http_response_1.HttpResponse({ body: data, ...rest });
        }
        else {
            console.error(response);
            return new http_response_1.HttpResponse({ body: {} });
        }
    }
}
exports.DefaultHttpClient = DefaultHttpClient;
//# sourceMappingURL=default-http.client.js.map